import { IGenericAsset } from "models/assets.models";
import { getARNWithoutVersion } from "screens/Project/screens/StructuredDocument/StructuredDocument.utils";
import { DocumentSubtype } from "utils/constants/doc.constants";
import { Path } from "utils/constants/paths.constants";
import { getRelativeUrlWithSearchParams } from "utils/helpers/searchParams/getRelativeUrlWithSearchParams";

const getDocumentPath = (
  projectId: string | undefined,
  document:
    | (Pick<IGenericAsset, "id" | "type"> &
        Partial<Pick<IGenericAsset, "source" | "parent" | "latestVersion">>)
    | undefined,
  version?: string,
) => {
  if (document?.type === DocumentSubtype.StructuredDocument) {
    const structuredDocumentVersion =
      version ?? document?.latestVersion?.version;

    /*TODO(KM): This will be fixed in FTE-56873
     *once the backend is updated to accept the version parameter and return the correct document by the unversioned ARN
     */
    const documentId = getARNWithoutVersion(document?.id);

    return (
      getStructuredDocumentPath(projectId, documentId) +
      (structuredDocumentVersion ? `?version=${structuredDocumentVersion}` : "")
    );
  }

  if (document?.type === DocumentSubtype.ECTD) {
    return Path.ProjectECTD.replace(":projectId", projectId ?? "").replace(
      ":ECTDId",
      document?.id ?? "",
    );
  }

  if (document?.parent && document?.parent?.type === DocumentSubtype.ECTD) {
    return `${Path.ProjectECTD.replace(":projectId", projectId ?? "").replace(
      ":ECTDId",
      document?.parent?.id ?? "",
    )}${document?.source?.arn ? `?documentId=${document?.source?.arn}` : ""}`;
  }

  if (document?.parent?.type === DocumentSubtype.StructuredDocument) {
    const parentStructuredDocumentId = getARNWithoutVersion(document.parent.id);

    const parentStructuredDocumentVersion =
      document.parent.latestVersion?.version;

    const documentId = getARNWithoutVersion(
      document.source?.arn ?? document.id,
    );

    const basePath = Path.ProjectStructuredDocument.replace(
      ":projectId",
      projectId ?? "",
    ).replace(":structuredDocumentId", parentStructuredDocumentId);

    return getRelativeUrlWithSearchParams(basePath, {
      version: parentStructuredDocumentVersion ?? "",
      documentId: documentId ?? "",
    });
  }

  return document
    ? Path.ProjectDocument.replace(":projectId", projectId ?? "").replace(
        ":documentId",
        document.id,
      )
    : Path.ProjectDocuments.replace(":projectId", projectId ?? "");
};

export const getStructuredDocumentPath = (
  projectId: string | undefined,
  documentId: string | undefined,
) =>
  Path.ProjectStructuredDocument.replace(":projectId", projectId ?? "").replace(
    ":structuredDocumentId",
    documentId ?? "",
  );

export default getDocumentPath;
